import { Observable } from 'rxjs'
import { Product, ProductAdapter } from '@spartacus/core'

export abstract class MbProductAdapter extends ProductAdapter {

  abstract loadProductOnProductCode(productCode: string): Observable<Product>
}
